import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import {
	toggleModalVisibility,
	reducer as incognitoPackagesReducer,
} from "ducks/incognito_packages";
import incognitoPackagesAnalytics from "analytics/incognito_packages";

import IncognitoPackages from "apps/incognito_packages";

import OnDOMReady from "shared/util/OnDOMReady";
import addToGlobalStore from "shared/redux/addToGlobalStore";
import addToGlobalAnalyticsMiddleware from "shared/redux/addToGlobalAnalyticsMiddleware";

OnDOMReady(() => {
	const store = addToGlobalStore({
		incognitoPackages: incognitoPackagesReducer,
	});

	addToGlobalAnalyticsMiddleware({
		incognitoPackages: incognitoPackagesAnalytics,
	});

	const target = document.getElementById("incognito_packages");

	if (target) {
		render(
			<Provider store={store}>
				<IncognitoPackages />
			</Provider>,
			target,
		);
	}

	window.IncognitoPackages = {
		has() {
			return true;
		},

		open() {
			store.dispatch(toggleModalVisibility(true));
		},

		close() {
			store.dispatch(toggleModalVisibility(false));
		},
	};
});



// WEBPACK FOOTER //
// ./src/features/incognito_packages/index.js